import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Skeleton } from "antd";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import { APIConstants } from "../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { calculateDateRangeFromDate } from "../../../../../../Utils/DateConverstion";
import {
  CheckCircleFilled,
  CloseCircleFilled, 
  ClockCircleFilled,
  FilterOutlined,
} from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";

const ParameterView = () => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [open, setOpen] = useState(false);
  const [sectionId, setSectionId] = useState(null);
  const [converterGroupId, setConverterGroupId] = useState(null);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [MeterData, setMeterData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [flowSectionList, setFlowSectionList] = useState([]);
  const [flowConverterList, setFlowConverterList] = useState([]);
  const [flowGroupDetailList, setFlowGroupDetailList] = useState([]);
  const [nsFlowConverterList, setNsFlowConverterList] = useState([]);
  const [GroupMeterList, setGroupMeterList] = useState([]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [input, setInput] = useState(null);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const fetchMeterLive = () => {
    setIsLoading(true) 
    const input = JSON.parse(localStorage.getItem("inputData"));
    console.log(input)
    const url = `${APIConstants.ELECTRICAL_PARAMETER_VIEW}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    console.log("URL :", url);

    makeRequest({ type: APIConstants.GET, url: url })
      .then((res) => {
        console.log("Meter Data Response:", res);
        if(res&&res.length>0){
          
          setMeterData(res);
        }
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching meter data:", error);
      });
  };

  console.log("Loading :", isLoading);

  useEffect(() => {
    if (input) {
      fetchMeterLive(input);
    }
  }, [input]);

  const fetchNsFlow = (id) => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_COVERTER_DETAILS}?ConverterID=${id}`,
    }).then((res) => {
      console.log("Converter Details :", res);
      if(res&&res.length>0){
          
        setNsFlowConverterList(res);
      }
    });
  };

  useEffect(() => {
    if (converterGroupId) {
      fetchNsFlow(converterGroupId);
    }
  }, [converterGroupId]);

  const fetchGroupMeter = (id) => {
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${id}&Module=1`,
    }).then((res) => {
      console.log("Meter details :", res);
      if(res&&res.length>0){
        setGroupMeterList(res); 
      }
    });
  };

  useEffect(() => {
    if (converterGroupId) {
      fetchGroupMeter(converterGroupId);
    }
  }, [converterGroupId]);

  useEffect(() => {
    makeRequest({
      type: APIConstants.POST,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
    }).then((res) => {
      console.log(res);
      if(res&&res.length>0){
          
        setFlowGroupDetailList(res);
      }
    });
  }, []);

  useEffect(() => {
    setIsLoading(true);

    Promise.all([
      makeRequest({
        type: APIConstants.GET,
        url: APIConstants.GET_FLOW_SECTION_MASTER_DETAILS,
      }),
      makeRequest({
        type: APIConstants.GET,
        url: APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS,
      }),
      makeRequest({
        type: APIConstants.GET,
        url: APIConstants.GET_STEAM_FLOW_GROUP_DETAILS,
      }),
    ])
      .then(([sections, converters, groups]) => {
        console.log("Sections:", sections);
        console.log("Converters:", converters);
        console.log("Groups:", groups);

        setFlowSectionList(sections);
        setFlowConverterList(converters);
        // setFlowGroupDetailList(groups);
      })
      .catch((error) => {
        console.error("Error fetching initial data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds([]);
    setConverterGroupId(null);
    setSubmitClicked(false);
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSubmitClicked(false);
    setSelectedMeterIds([]);
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (!selectedValues.length) {
      setSubmitClicked(false);
    }
  };

    useEffect(() => {
    const interval = setInterval(() => {
      console.log("1 minute passed");
      fetchMeterLive()
    }, 60000); // 60000 ms = 1 minute
  
    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  const setInputData = () => {
    const ids = selectedMeterIds?.join(",");

    const currentDate = new Date();
    console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    console.log("From Date :", from);
    console.log("To Date :", to);
    console.log("CURRENT DATE :", currentDate);
    // const from="11-13-2024"
    // const to="11-13-2024"
    const encodedMeterIds = encodeURIComponent(ids);

    const inputData = {
      SectionID: Number(sectionId),
      ConverterorGroupID: Number(converterGroupId),
      MeterIds: encodedMeterIds,
      FromDate: from,
      ToDate: to,
    };
    localStorage.setItem("inputData", JSON.stringify(inputData));
    setInput(inputData);
  };

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter/Group");
    const meterError = validateInput(selectedMeterIds.length > 0, "Meter");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);

    if (!sectionError && !converterError && !meterError) {
      setInputData();
      onClose();
    } else {
      setSubmitClicked(true);
    }
  };

  const columnDefs = [
    {
      headerName: "STATUS",
      field: "status",
      headerStyle: { fontWeight: "800" },
      width: 90,
      pinned: "left",
      cellRenderer: (params) => {
        let icon;
        if (params.data.meterStatus === "ON") {
          icon = (
            <CheckCircleFilled style={{ fontSize: "20px", color: "green" }} />
          );
        } else if (params.data.meterStatus === "OFF") {
          icon = (
            <CloseCircleFilled style={{ fontSize: "20px", color: "red" }} />
          );
        } else if (params.data.meterStatus === "idle") {
          icon = (
            <ClockCircleFilled style={{ fontSize: "20px", color: "yellow" }} />
          );
        }
        //   else {
        //   icon = <ClockCircleFilled style={{ fontSize: '20px', color: 'yellow' }} />;
        // }

        return (
          <div
            style={{
              margin: "5px",
              marginLeft: "10px",
              border: "none",
              outline: "none",
            }}
          >
            {icon}
          </div>
        );
      },
    },
    {
      headerName: "SITE NAME",
      field: "siteName",
      headerStyle: { fontWeight: "800" },
      width: 170,
      pinned: "left",
    },
    {
      headerName: "METER NAME",
      field: "metername",
      headerStyle: { fontWeight: "800" },
      width: 170,
      pinned: "left",
    },
    {
      headerName: "METER ID",
      field: "meterId",
      headerStyle: { fontWeight: "800" },
      width: 100,
      pinned: "left",
    },
    {
      headerName: "VR",
      field: "vr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VY",
      field: "vy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VB",
      field: "vb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "F",
      field: "f",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VRY",
      field: "vry",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VYB",
      field: "vyb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VBR",
      field: "vbr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "VLLAvg",
      field: "vllAvg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IR",
      field: "ir",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IY",
      field: "iy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IB",
      field: "ib",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "IAVG",
      field: "iavg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "Vunb",
      field: "vunb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "lunb",
      field: "iunb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWT",
      field: "kwt",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAT",
      field: "kvat",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVART",
      field: "kvart",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFT",
      field: "pft",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFR",
      field: "pfr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFY",
      field: "pfy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "PFB",
      field: "pfb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWR",
      field: "kwr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWY",
      field: "kwy",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWB",
      field: "kwb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAR",
      field: "kvaR_R",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAY",
      field: "kvA_Y",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAB",
      field: "kvaR_B",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVARR",
      field: "kvarr",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVARY",
      field: "kvaR_Y",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVARB",
      field: "kvarb",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWD",
      field: "kwd",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KVAD",
      field: "kvad",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "KWHTotal",
      field: "kwhTotal",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KWHImport",
      field: "kWhImport",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KWHExport",
      field: "kwhexport",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KVAH",
      field: "kVAh",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KVARHTotal",
      field: "kVArhTotal",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "KVARHInductive",
      field: "kVArInductive",
      headerStyle: { fontWeight: "800" },
      width: 160,
    },
    {
      headerName: "KVARHCapacitive",
      field: "kvarH_CAPACITIVE",
      headerStyle: { fontWeight: "800" },
      width: 160,
    },
    {
      headerName: "CREATED ON",
      field: "createdOn",
      headerStyle: { fontWeight: "800" },
      width: 130,
    },
    {
      headerName: "V THD AVG",
      field: "v_THDAvg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "V THD R",
      field: "v_THDR",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "V THD Y",
      field: "v_THDY",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "V THD B",
      field: "v_THDB",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD AVG",
      field: "i_THDAvg",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD R",
      field: "i_THDR",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD Y",
      field: "i_THDY",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
    {
      headerName: "I THD B",
      field: "i_THDB",
      headerStyle: { fontWeight: "800" },
      width: 100,
    },
  ];

  console.log(MeterData);
   const color = useSelector((state) => state.ThemeChange);
    console.log(color)

  return (
    <div className="w-full p-4">
      <div className="flex justify-between items-center px-2 pb-0">
        <div className="text-3xl">
        <h4 className={`text-left text-[30px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>
            PARAMETER VIEW
        </h4> 
        </div>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
      </div>

      { MeterData && MeterData.length>0 ? (
         
        <div
          className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
          style={{
            '--ag-header-background-color': color.themeConfig.colorPrimary, 
            '--ag-header-foreground-color': '#fff', 
            height: "80vh", width: "100%", overflowY: "auto" 
          }}
        >
          <AgGridReact
            columnDefs={columnDefs}
            rowData={MeterData}
            pagination={true}
            domLayout="normal"
            defaultColDef={{  
              resizable: true,
            }}
            rowHeight={50}
            suppressHorizontalScroll={false}
          />
        </div>
      ) : (
        <div className={`${!isdarkMode ? "text-black " : "text-white "} text-center`}
        >
          <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
        </div>
      )}

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        className={`dark ${isdarkMode ? "darkmode" : "whitemode"}`}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={flowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          {sectionError && (
            <small className="font-bold ml-[150px] text-red-500">
              {sectionError}
            </small>
          )}
          <CustomSelect
            label="Converter / Group:"
            options={sectionId === 1 ? flowConverterList : flowGroupDetailList}
            onSelect={handleChangeConverterGroup}
            // valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            // nameKey={sectionId === 1 ? "sitename" : "department"}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
          />
          {converterError && (
            <small className="text-red-500 font-bold ml-[150px]">
              {converterError}
            </small>
          )}
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={sectionId === 1 ? nsFlowConverterList : GroupMeterList}
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          {meterError && (
            <small className="text-red-500 font-bold ml-[150px]">
              {meterError}
            </small>
          )}
        </div>
        <div className="flex justify-center mt-4">
                     <Button
                       type= {isdarkMode? "":'primary'}
                       onClick={() => {
                         handleSubmit();
                       }}
                     >
                       Search
                     </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default ParameterView;
